/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/

import { VisionApplication } from '../application';
import { IPubSubSubscriber } from '../pubsub';
import { BaseService } from './base';
import { AddressInformation } from './latest';

export interface DeviceTelemetryDTO {
    id: string;
    assetId: string;
    timestamp: string;
    lat: number;
    lon: number;
    heading: number;
    speed: number;
    ignition: boolean;
    input1: boolean;
    input2: boolean;
    input3: boolean;
    input4: boolean;
}

export class AssetTelemetryService extends BaseService implements IPubSubSubscriber {
    identifier: string;

    constructor(_app: VisionApplication) {
        super();
        this.identifier = '8a4378bf-fd83-4210-9428-2cc863fe5ff8';
    }

    public async init() {
        return new Promise((resolve, _reject) => {
            console.log('Telemetry Service Loaded');
            resolve('Loaded');
        });
    }

    async getAssetTelemetry(asset: string, start: string, end: string) {
        const response = await this.get<DeviceTelemetryDTO[]>(this.url + '/api/' + this.orgid + '/telemetry/' + asset + '?start=' + start + '&end=' + end);
        return response;
    }

    async getAssetTelemetryPaged(asset: string, start: string, end: string, page: number) {
        const response = await this.get<DeviceTelemetryDTO[]>(this.url + '/api/' + this.orgid + '/telemetry/page/' + asset + '?start=' + start + '&end=' + end + '&page=' + page + '&size=10');
        return response;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notify(msg: string, _data?: any): void {
        console.log(msg);
    }

    async getAddress(lat: number, lon: number) {
        const response = await this.get<AddressInformation>(this.url + '/api/' + this.orgid + '/telemetry/address?latitude=' + lat + '&longitude=' + lon);
        return response;
    }
}
